module.exports = __webpack_public_path__ + "img/14.4dc2d1e3.jpg";